import { computed, ref } from "vue";
import { getUniqueString } from "./utils.js";
function cachedRef(key, defaultValue) {
  const reference = ref(JSON.parse(window.localStorage.getItem(key)) || defaultValue);
  return computed({
    get: () => reference.value,
    set(value) {
      window.localStorage.setItem(key, JSON.stringify(value));
      reference.value = value;
    }
  });
}
function computedModel(model, handler) {
  return computed({
    get: () => model.value,
    set: (e) => handler(e, model.value)
  });
}
function idMap(prefix) {
  const map = [];
  function add() {
    const id = getUniqueString(prefix);
    map.push(id);
    return id;
  }
  function remove(index) {
    const [id] = map.splice(index, 1);
    return id;
  }
  function get(index) {
    let id = map[index];
    if (!id) {
      id = getUniqueString(prefix);
      map.splice(index, 0, id);
    }
    return id;
  }
  return {
    addId: add,
    removeId: remove,
    getId: get
  };
}
export {
  cachedRef,
  computedModel,
  idMap
};
//# sourceMappingURL=utils_vue.js.map
